/*
 TPayStandard

 Tresc regulaminu platnosci internetowych dla TPay Standard
  
 historia: 
  PM 2021-10-14 - start
*/

import * as React from 'react';

import { Typography } from '@material-ui/core';

class TPayStandard extends React.Component<any, any> {

    //PM 2021-11-05
    //variant='body2'
    //poprawka DOM
    render() {

        return (
            <React.Fragment>
                <Typography variant='h6'>REGULAMIN PŁATNOŚCI ZA POŚREDNICTWEM SERWISU Tpay</Typography>
                <br />
                <Typography variant='body2' align="center">§ 1</Typography>
                <br />
                <Typography variant='body2' align="center">Postanowienia ogólne</Typography>
                <br />
                <Typography variant='body2' align="center">Niniejszy Regulamin określa zasady dokonywania wpłat dla nazwa_firmy za pośrednictwem Serwisu Tpay.</Typography>
                <br />
                <Typography variant='body2' align="center">§ 2</Typography>
                <br />
                <Typography variant='body2' align="center">Definicje</Typography>
                <br />
                <Typography variant='body2'>Określenia użyte w niniejszym regulaminie oznaczają:</Typography>
                <br />
                <Typography variant='body2'>Odbiorca płatności – nazwa_firmy ul. ulica nr_domu/nr_lokalu, kod_pocztowy miasto, NIP 0000000000, REGON 000000000.</Typography>
                <br />
                <Typography variant='body2'>Płatnik – osoba fizyczna mająca pełną zdolność do czynności prawnych, osoba prawna lub jednostka organizacyjna niebędąca osobą prawną, której ustawa przyznaje zdolność prawną, która dokonuje płatności na rzecz Odbiorcy płatności.</Typography>
                <br />
                <Typography variant='body2'>Operator płatności –Tpay – System płatności Tpay należy do spółki, Krajowy Integrator Płatności S.A. ul. Św. Marcin 73/6, 61-808 Poznań , NIP: 7773061579, REGON: 300878437, KRS: 0000412357 Kapitał zakładowy: 5.494.980 PLN wpłacony w całości.</Typography>
                <br />
                <Typography variant='body2'>Serwis  internetowy – serwis Tpay pośredniczący w przekazywaniu darowizny pomiędzy Odbiorcą płatności a Płatnikiem.</Typography>
                <br />
                <Typography variant='body2'>Płatność – dokonywana przez Płatnika wpłata na rzecz Odbiorcy płatności z wykorzystaniem Serwisu.</Typography>
                <br />
                <Typography variant='body2' align="center">§ 3</Typography>
                <br />
                <Typography variant='body2'>Odbiorcą płatności jest nazwa_firmy ul. ulica nr_domu/nr_lokalu, kod_pocztowy miasto, NIP 0000000000, REGON 000000000.</Typography>
                <br />
                <Typography variant='body2'>Podmiotem świadczącym usługę płatniczą, zwaną dalej w niniejszym regulaminie „Usługą Tpay” na rzecz Użytkowników jest Operator płatności. Operator płatności realizując Usługę Tpay występuje jako dostawca usług płatniczych w rozumieniu ustawy z dnia 19 sierpnia 2017 r. o Usługach płatniczych. (Dz.U. 2016.1572 t.j.). Wszystkie transakcje przeprowadzane są podczas połączenia szyfrowanego najwyższej jakości certyfikatem wystawionym przez PCC CERTUM. Spółka KIP S.A. spełnia szereg rygorystycznych wymogów związanych z bezpieczeństwem finansowym, operacyjnym i prawnym. Jako pełnoprawna instytucja finansowa jest ściśle nadzorowana przez Komisję Nadzoru Finansowego świadcząc usługi w charakterze Krajowej Instytucji Płatniczej. Każda wpłata dokonana przez Płatnika stanowi wpłatę za usługi nazwa_firmy.</Typography>
                <br />
                <Typography variant='body2'>Wpłaty przekazywane za pośrednictwem Tpay będą przekazywane na rachunek bankowy: 00 0000 0000 0000 0000 0000 0000.</Typography>
                <br />
                <Typography variant='body2' align="center">§ 4</Typography>
                <br />
                <Typography variant='body2' align="center">Reklamacje i zwroty</Typography>
                <br />
                <Typography variant='body2'>Odbiorca płatności przewiduje zwrot wpłaconych środków i reklamacji w zależności od warunków usługi, którą opłaca płatnik.</Typography>
                <br />
                <Typography variant='body2'>Użytkownik może złożyć reklamację, jeśli wpłaty, o których mowa w Regulaminie płatności w & 3 ust. 3 nie zostały zrealizowane lub są realizowane niezgodnie z jego postanowieniami. Reklamacje można złożyć w formie: pisemnej - osobiście pod adresem nazwa_firmy, ul. ulica nr_domu/nr_lokalu, kod_pocztowy miasto, lub przesyłką pocztową art. 3 punkt 21 ustawy z dnia 23 listopada 2012 r. – Prawo Pocztowe (Dz. U. poz 1529 z późn. zm), elektronicznej – w formie wiadomości e-mail przesłanej na adres e-mail: email@email.pl.</Typography>
                <br />
                <Typography variant='body2' align="center">§ 5</Typography>
                <br />
                <Typography variant='body2'>Niniejszy Regulamin jest udostępniony w nazwa_firmy, ul. ulica nr_domu/nr_lokalu, kod_pocztowy miasto oraz na stronie internetowej adres_strony_interetowej.</Typography>
                <br />
                <Typography variant='body2'>W zakresie nieregulowanym niniejszym Regulaminem zastosowanie mają powszechnie obowiązujące przepisy prawa.</Typography>
            </React.Fragment>
        );
    }
}

export default TPayStandard;
